import { AssignmentStatusEnum, SectionTypeEnum } from "@imaginelearning/mps-api-service";
import { IScored } from "./link-launch-types";

const PASSING_SCORE = 70;

export const messages = {
  // These messages get translated in the ActivityTransitionModal
  beforequiz: {
    head: "PracticeBeforeQuizTitle",
    body: "PracticeBeforeQuizBody",
    activityType: SectionTypeEnum.ACTIVITY,
    activityStatus: AssignmentStatusEnum.NOT_STARTED,
    canExit: false,
    showScore: false
  },
  afterquizpassed: {
    head: "PracticeAfterQuizPassedTitle",
    body: "PracticeAfterQuizPassedBody",
    activityType: SectionTypeEnum.ACTIVITY,
    activityStatus: AssignmentStatusEnum.PASSED,
    canExit: false,
    showScore: true
  },
  afterquiznotpassed: {
    head: "PracticeAfterQuizNotPassedTitle",
    body: "PracticeAfterQuizNotPassedBody",
    activityType: SectionTypeEnum.ACTIVITY,
    activityStatus: AssignmentStatusEnum.NOT_PASSED,
    canExit: false,
    showScore: true
  },
  activityInProgress: {
    head: "PracticeActivityInProgressTitle",
    body: "PracticeActivityInProgressBody",
    activityType: SectionTypeEnum.ACTIVITY,
    activityStatus: AssignmentStatusEnum.NOT_STARTED,
    canExit: true,
    showScore: false
  },
  activityPassed: {
    head: "PracticeActivityPassedTitle",
    body: "PracticeActivityPassedBody",
    activityType: SectionTypeEnum.ACTIVITY,
    activityStatus: AssignmentStatusEnum.PASSED,
    canExit: false,
    showScore: true
  },
  activityNotPassed: {
    head: "PracticeActivityNotPassedTitle",
    body: "PracticeActivityNotPassedBody",
    activityType: SectionTypeEnum.ACTIVITY,
    activityStatus: AssignmentStatusEnum.NOT_PASSED,
    canExit: false,
    showScore: true
  },
  lessonComplete: {
    head: "PracticeLessonCompletedTitle",
    body: "PracticeLessonCompletedBody",
    activityType: SectionTypeEnum.LESSON,
    activityStatus: AssignmentStatusEnum.NOT_STARTED,
    canExit: false,
    showScore: true
  },
  lessonPassed: {
    head: "PracticeLessonPassedTitle",
    body: "PracticeLessonPassedBody",
    activityType: SectionTypeEnum.LESSON,
    activityStatus: AssignmentStatusEnum.PASSED,
    canExit: false,
    showScore: true
  },
  lessonNotPassed: {
    head: "PracticeLessonNotPassedTitle",
    body: "PracticeLessonNotPassedBody",
    activityType: SectionTypeEnum.LESSON,
    activityStatus: AssignmentStatusEnum.NOT_PASSED,
    canExit: false,
    showScore: true
  },
  pathwayLessonPassed: {
    //add
    head: "PracticePathwayLessonPassedTitle",
    body: "PracticePathwayLessonPassedBody",
    activityType: SectionTypeEnum.LESSON,
    activityStatus: AssignmentStatusEnum.PASSED,
    canExit: false,
    score: true
  },
  pathwayLessonNotPassed: {
    //add
    head: "PracticePathwayLessonNotPassedTitle",
    body: "PracticePathwayLessonNotPassedBody",
    activityType: SectionTypeEnum.LESSON,
    activityStatus: AssignmentStatusEnum.NOT_PASSED,
    canExit: false,
    score: true
  }
};

export const isQuiz = (activityType: string | undefined) => {
  if (!activityType) {
    return false;
  }
  const validActivityTypes = ["prequiz", "postquiz"];
  if (validActivityTypes.includes(activityType.toLowerCase())) {
    return true;
  }
  return false;
};

export const getMessageBasedOnScored = (
  scored: IScored,
  activityType: string,
  lessonComplete: boolean,
  startNextActivity: Function,
  isAssignment: boolean = true
) => {
  if (scored) {
    if (lessonComplete) {
      return getLessonCompletionMessage(scored, isAssignment);
    }

    if (isQuiz(activityType)) {
      return getQuizCompletionMessage(scored);
    }

    if (!isAssignment) {
      //pathways
      return messages.activityPassed;
    }

    startNextActivity();
  }
};

const getLessonCompletionMessage = (scored: IScored, isAssignment: boolean) => {
  if (scored.scorePercent && scored.scorePercent >= PASSING_SCORE) {
    return isAssignment ? messages.lessonPassed : messages.pathwayLessonPassed;
  } else {
    return isAssignment ? messages.lessonNotPassed : messages.pathwayLessonNotPassed;
  }
};

const getQuizCompletionMessage = (scored: IScored) => {
  return scored.scorePercent && scored.scorePercent >= PASSING_SCORE
    ? messages.afterquizpassed
    : messages.afterquiznotpassed;
};
